import {Axios, Base} from "@/api/Base"

const api = "space"

export class SpaceGetTree extends Base {
    path = api + "/getTree"
}

export class SpaceGetTreeByUserId extends Base {
  path = api + "/getTreeByUserId"
}

export class SpaceInfoByUserId extends Base {
    path = api + "/getInfoByUserId"
}

export class SpaceInfoBySpaceId extends Base {
  path = api + "/getInfoBySpaceId"
}


export class SpaceGetSpaceIdsByUserId extends Base {
    path = api + "/getSpaceIdsByUserId"
}